import React from 'react'
import { MainProduct } from 'services/api/entities/catalog/mainProduct/types/internal/mainProduct-models'
import EventBaseSelectionInputWrapper, {
  EventBaseSelectionInputWrapperProps,
} from './EventBaseSelectionInputWrapper'
import MainProductSelectionInputContent, {
  MainProductSelectionInputContentProps,
} from './MainProductSelectionInputContent'

export type EventMainProductSelectionInputProps<T extends MainProduct> = Omit<
  EventBaseSelectionInputWrapperProps,
  'children'
> &
  MainProductSelectionInputContentProps<T> & {
    children?: React.ReactNode
  }

const EventMainProductSelectionInput = <T extends MainProduct>({
  children,
  label,
  disableInputs,
  choices,
  hideQuantity,
  getIsProductObsolete,
  disableProductChoiceAfterSelections,
  ...rest
}: EventMainProductSelectionInputProps<T>) => (
  <EventBaseSelectionInputWrapper {...rest}>
    <MainProductSelectionInputContent
      label={label}
      disableInputs={disableInputs}
      choices={choices}
      hideQuantity={hideQuantity}
      getIsProductObsolete={getIsProductObsolete}
      disableProductChoiceAfterSelections={disableProductChoiceAfterSelections}
    >
      {children}
    </MainProductSelectionInputContent>
  </EventBaseSelectionInputWrapper>
)

export default EventMainProductSelectionInput
